<template>
    <div class="photos">
        <div style="padding:0px 12px;">
            <h2>Фотоальбомы</h2>
            <btn l='Создать альбом' i="plus" t='p' s='m' @press="createAlbum" />
            <hr />
            <i-list :fields="fields" :data="photoAlbums" @input="openAlbum" />
        </div>
        <modal name='photo-album-edit-modal' title='Редактор альбома' :width="800" :noFooter="false">
            <i-form :showSaveButton="false" padding="6" :scheme="albumScheme" :data="currentAlbum" @input="save" />
            <div slot="footer">
                <btn l="Удалить альбом" t='d' s='m' i='trash' @press="remove" pull='left'></btn>
                <btn l="Сохранить альбом" t='s' s='m' i='save' @press="saveForm" pull='right'></btn>
                <btn l="Отмена" t='df' s='m' i='times' @press="cancel" pull='right'></btn>
            </div>
        </modal>
    </div>
</template>
<script>
let { crudApi, bus } = window._i;
export default {
    props: {},
    name: 'photos',
    methods: {
        createAlbum() {
            this.currentAlbum = { photos: [] };
            this.$store.commit('modalOpen', 'photo-album-edit-modal');
        },
        remove() {
            this.$store.dispatch("photosRemoveCRUD", this.currentAlbum._id);
            this.$store.commit('modalClose', 'photo-album-edit-modal');
        },
        cancel() { this.$store.commit('modalClose', 'photo-album-edit-modal'); },
        saveForm() { bus.$emit('save-form'); },
        save(album) {
            this.$store.dispatch("photosSaveCRUD", album);
            this.$store.commit('modalClose', 'photo-album-edit-modal');
        },
        openAlbum(album) {
            console.log(album);
            this.currentAlbum = album;
            this.$store.commit('modalOpen', 'photo-album-edit-modal');
        }
    },
    data() {
        return {
            albumScheme: {
                title: { type: 'string', label: "Название" },
                description: { type: 'string', label: "Описание" },
                photos: {
                    type: 'array',
                    label: "Фотографии",
                    scheme: {
                        src: { type: "image", label: "Изображение" },
                        title: { type: "string", label: "Заголовок" },
                        //description: {type:"date", label:"Описание"},
                        //date: {type:"date", label:"Дата"}
                    }
                }
            },
            currentAlbum: {},
            fields: [
                /*{
                  "label": "ID",
                  "name": "_id"
                },*/
                {
                    "label": "ID",
                    "name": "_id",
                    type: 'index'
                },
                {
                    "label": "Название Альбома",
                    "name": "title"
                },
                {
                    "label": "Краткое описание",
                    "name": "description"
                }
            ]
        }
    },
    computed: {
        photoAlbums() {
            return this.$store.state.photos.list;
        }
    },
    created() {
        crudApi.makeStore(this, 'photos', 'content/photos');
        /*this.$store.registerModule('photos', {
          state: {
            albums:[],
            loaded:false
          },
          mutations: {
            albumUpdate(state, album){
              let foundIndex = state.albums.findIndex((p)=>{
                if(p._id === album._id) return true;
                else return false;
              });
              console.log(foundIndex)
              if(foundIndex != -1){
                  state.albums[foundIndex] = album;
                } else {
                  state.albums.push(album);
                }
            },
            albumRemove(state,albumId){
              state.albums = state.albums.filter(f=>{return f._id!==albumId});
            }
          },
          actions:{
            loadPhotos({commit,state}, page = 0){
              self.$http.get('content/photos').then((res)=>{
                let {error,albums,photos} = res.body;
                state.albums= albums;
                state.photos= photos;
                state.loaded = true;
              });
            },
            saveAlbum({commit,state}, album){
              self.$http.post('content/photos',album).then((res)=>{
                let {error,album} = res.body;
                commit("albumUpdate",album);
              });
            },
            removeAlbum({commit,state}, albumId){
              self.$http.delete('content/photos',{body:{_id:albumId}}).then((res)=>{
                commit("albumRemove",albumId);
              });
            }
          }
        });

        this.$store.dispatch('loadPhotos');*/
    },
}
</script>
<style lang="css" scoped>
</style>